/**
 * @generated SignedSource<<d8071506e5f00ab52d159070fcaf16cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Balance_balance$data = {
  readonly id: string;
  readonly amount: {
    readonly formatted: string;
  };
  readonly " $fragmentType": "Balance_balance";
};
export type Balance_balance$key = {
  readonly " $data"?: Balance_balance$data;
  readonly " $fragmentSpreads": FragmentRefs<"Balance_balance">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./BalanceRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "Balance_balance",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MoneyAmount",
      "kind": "LinkedField",
      "name": "amount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formatted",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Balance",
  "abstractKey": null
};

(node as any).hash = "32e59d99455da971088506b6350b84aa";

export default node;
